module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "hidden-xs hidden-sm footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("地图")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://map.ishowchina.com"
    }
  }, [_vm._v("web地图")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://app.ishowchina.com"
    }
  }, [_vm._v("移动地图")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://streetview.ishowchina.com/"
    }
  }, [_vm._v("全景地图")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("地图服务")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://dev.ishowchina.com"
    }
  }, [_vm._v("地图开放平台")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://www.ishowchina.com/tracecloud.html"
    }
  }, [_vm._v("轨迹云端管理")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://www.ishowchina.com/cloudmap.html"
    }
  }, [_vm._v("地图在线制作")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("物联网")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/beyond.html"
    }
  }, [_vm._v("车联网")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/citymanage.html"
    }
  }, [_vm._v("智慧城市")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/smartadministor.html"
    }
  }, [_vm._v("智慧城管")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/police.html"
    }
  }, [_vm._v("公安行业应用")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("大数据")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/datademo.html"
    }
  }, [_vm._v("行业数据")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://www.ishowchina.com/cloudmap.html"
    }
  }, [_vm._v("数据可视化")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/measure.html"
    }
  }, [_vm._v("地图数据采集")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://datastore.ishowchina.com/index.htm"
    }
  }, [_vm._v("数据商城")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("行业解决方案")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/estate.html"
    }
  }, [_vm._v("房地产行业解决方案")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/bigData.html"
    }
  }, [_vm._v("大数据行业解决方案")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/smartlogistics.html"
    }
  }, [_vm._v("智慧物流解决方案")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://solution.ishowchina.com/smarttravel.html"
    }
  }, [_vm._v("智慧旅游解决方案")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://about.ishowchina.com"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://about.ishowchina.com/connect.html"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://about.ishowchina.com/legal.html"
    }
  }, [_vm._v("法律声明")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://about.ishowchina.com/help.html"
    }
  }, [_vm._v("帮助中心")])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "userfreeback",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("意见反馈")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerItem"
  }, [_c('p', {
    staticClass: "footertitle"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "lxwm"
  }, [_c('img', {
    staticClass: "footerIcon",
    attrs: {
      "src": require("./images/footer/email.png")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mail",
    attrs: {
      "href": "mailto:bd@leador.com.cn"
    }
  }, [_vm._v("bd@leador.com.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "lxwm"
  }, [_c('img', {
    staticClass: "footerIcon",
    attrs: {
      "src": require("./images/footer/tel.png")
    }
  }), _vm._v(" 15201338330（同微信）\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "lxwm"
  }, [_c('img', {
    staticClass: "footerIcon",
    attrs: {
      "src": require("./images/footer/q.png")
    }
  }), _vm._v(" 127817479\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "lxwm"
  }, [_c('img', {
    staticClass: "footerIcon address",
    attrs: {
      "src": require("./images/footer/adress.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "addressSpan"
  }, [_vm._v("北京市海淀区中关村军民融合产业园B座106")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footerItem focus_us"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-xs-12 qrcode-title footertitle"
  }, [_vm._v("关注我们")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-wrap col-xs-6"
  }, [_c('a', {
    attrs: {
      "title": "微信公众号"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/footer/weixin.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "wx"
  }, [_vm._v("我秀地图")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-wrap col-xs-6"
  }, [_c('a', {
    attrs: {
      "title": "新浪微博"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/footer/xinlang.jpg")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "wx"
  }, [_vm._v("我秀中国官方微博")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid icp"
  }, [_c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "28px"
    }
  }, [_vm._v("版权所有 ©"), _c('span', {
    attrs: {
      "id": "copy_icp"
    }
  }, [_vm._v("2018")]), _vm._v("\n\t\t北京秀友科技有限公司  经营许可证 B2-20090067 2009 ishowchina.com 甲测资字42002001\n\t\t"), _c('p', {
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "height": "20px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#c5c5c5",
      "font-size": "14px",
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("京ICP备15012051号-2")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e435d1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/decorator/footer.vue
// module id = 137
// module chunks = 1